export default __webpack_public_path__ + "static/IMG_4998-365f640aac63fad1cf96006e017133fb.jpg";